import React from 'react';
import { useAnimateIn } from '@/lib/useAnimateIn';

interface SuggestedResponsesProps {
  suggestions?: Array<{label: string; row_id: string}>;
  onResponseClick?: (response: {label: string; row_id: string}) => void;
  selectedRowIds?: string[];
  getButtonStyle?: (index: number) => React.CSSProperties;
}

export default function SuggestedResponses({ suggestions = [], onResponseClick, selectedRowIds = [], getButtonStyle }: SuggestedResponsesProps) {
  // Default suggestions if none provided
  const defaultSuggestions = [
    { label: "Our growth has slowed", row_id: "fallback_1" },
    { label: "My customer experience feels outdated", row_id: "fallback_2" },
    { label: "My data is not being put to use", row_id: "fallback_3" }
  ];
  
  const displaySuggestions = suggestions.length > 0 ? suggestions : defaultSuggestions;
  
  // Animate title in with opacity
  const { style: titleStyle } = useAnimateIn({ 
    delay: 0, 
    duration: 500, 
    translateDistance: 0, 
    easing: 'ease-out' 
  });

  return (
    <div id="suggested-responses" className='self-start mb-4 w-full'>
      <div className='suggested-responses-title text-sm text-[#666666] mb-3 flex items-center gap-1' style={titleStyle}>
        <span>✨</span>
        <span>Suggested responses:</span>
      </div>
      <div className='flex flex-wrap gap-2'>
        {displaySuggestions.map((suggestion, index) => {
          const isSelected = selectedRowIds.includes(suggestion.row_id);
          const staggerStyle = getButtonStyle ? getButtonStyle(index) : {};
          // Merge stagger animation styles with color transition styles
          // Include color properties in transition so hover works
          const mergedStyle = {
            ...staggerStyle,
            transitionProperty: staggerStyle.transitionProperty 
              ? `${staggerStyle.transitionProperty}, background-color, border-color, color`
              : 'background-color, border-color, color',
            // Use 700ms for all transitions to ensure color transitions work
            transitionDuration: '300ms',
            transitionTimingFunction: 'ease-out',
          };
          
          return (
            <button
              key={index}
              onClick={() => onResponseClick?.(suggestion)}
              style={mergedStyle}
              className={`px-4 py-2 rounded-full border text-sm text-left ${
                isSelected 
                  ? 'border-black bg-black text-white' 
                  : 'border-[#666666] text-[#666666] hover:border-black hover:text-black hover:bg-[#FFDC32]'
              }`}
            >
              {suggestion.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
